// src/components/Footer/Footer.jsx
import React from 'react';
import { Container, Row, Col, ListGroup, Button } from 'react-bootstrap';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <Container className="py-3">
                <Row className="gy-4">
                    {/* About Section */}
                    <Col lg={4} md={6}>
                        <h5 className="footer-heading mb-3">About Us</h5>
                        <p className="text-white-50 pe-lg-3" style={{ fontSize: '0.9rem', textAlign: 'justify' }}>
                            Shilpaa Electrical Infratech (India) Ltd started under the proprietary firm in the year 1997, later the firm is converted to private limited company in the year 2007. We take the privilege of introducing ourselves as one of the leading Electrical Contractors (Internal & External) Holding 'A' Grade Licence exceeding 33kv (All Voltages). We carry out installation of 220kv /132kv 33Kv /11kv Substations, HT & LT works for varius types of Government Sectors, Industries, Software Companies, Apartments and Buildings.
                        </p>
                    </Col>

                    {/* Quick Links Section */}
                    <Col lg={3} md={6}>
                        <h5 className="footer-heading mb-3">Quick Links</h5>
                        <ListGroup variant="flush" className="quick-links" style={{ fontSize: '0.9rem' }}>
                            <ListGroup.Item action href="/">Home</ListGroup.Item>
                            <ListGroup.Item action href="/about">About Us</ListGroup.Item>
                            <ListGroup.Item action href="#">Civil Engineering</ListGroup.Item>
                            <ListGroup.Item action href="#">Electrical Engineering</ListGroup.Item>
                            <ListGroup.Item action href="#">Careers</ListGroup.Item>
                            <ListGroup.Item action href="#">Gallery</ListGroup.Item>
                        </ListGroup>
                    </Col>

                    {/* Contact Info Section */}
                    <Col lg={5} md={12}>
                        <h5 className="footer-heading mb-3">Contact Us</h5>
                        <div className="contact-info" style={{ fontSize: '0.9rem' }}>
                            <div className="d-flex mb-2 align-items-start">
                                <i className="bi bi-geo-alt-fill me-2 contact-icon"></i>
                                <p className="text-white-50 mb-0">
                                    Flat no 3 & 20, Sony Business Complex, Prashanthi Nagar, Kukatpally, Hyderabad - 500027
                                </p>
                            </div>
                            <div className="d-flex mb-2 align-items-center">
                                <i className="bi bi-telephone-fill me-2 contact-icon"></i>
                                <div>
                                    <a href="tel:04023070769" className="text-white-50 text-decoration-none">040 - 23070769</a>
                                    {' / '}
                                    <a href="tel:04023073949" className="text-white-50 text-decoration-none">040 - 23073949</a>
                                </div>
                            </div>
                            <div className="d-flex mb-2 align-items-center">
                                <i className="bi bi-envelope-fill me-2 contact-icon"></i>
                                <a href="mailto:info@shilpaaengineers.com" className="text-white-50 text-decoration-none">
                                    info@shilpaaengineers.com
                                </a>
                            </div>
                            <div className="d-flex align-items-center">
                                <i className="bi bi-clock-fill me-2 contact-icon"></i>
                                <p className="text-white-50 mb-0">Mon - Sat: 9:00 AM - 6:00 PM</p>
                            </div>
                            {/* Social Links */}
                            <div className="social-links mt-3">
                                <Button size="sm" variant="outline-light" className="me-2" href="#" aria-label="LinkedIn">
                                    <i className="bi bi-linkedin"></i>
                                </Button>
                                <Button size="sm" variant="outline-light" className="me-2" href="#" aria-label="Facebook">
                                    <i className="bi bi-facebook"></i>
                                </Button>
                                <Button size="sm" variant="outline-light" href="#" aria-label="Twitter">
                                    <i className="bi bi-twitter-x"></i>
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>

                {/* Copyright */}
                <div className="text-center text-white-50 mt-4 pt-3 border-top border-secondary" style={{ fontSize: '0.8rem' }}>
                    © {new Date().getFullYear()} Shilpa Electrical Engineers Private Limited. All Rights Reserved.
                </div>
            </Container>
        </footer>
    );
}

export default Footer;